/* eslint-disable */
import React, { useEffect } from "react"

const DFPAdManager = () => {
    useEffect(() => {
        const init = () => {
            let s = document.createElement("script")
            s.type = "text/javascript"
            s.src =
                "https://assets.minutemediacdn.com/prebid/display-manager-core-1.0.0.js"
            document.body.appendChild(s)

            window.mmDisplayManager = window.mmDisplayManager || { cmd: [] }

            // First set your siteName via setSettings API. You need to do this one time before you call any other api.
            window.mmDisplayManager.cmd.push(() =>
                window.mmDisplayManager.setSettings({
                    siteName: `${window.location.origin}/what-should-i-binge-tv-quiz/`,
                })
            )
        }

        init()
    }, [])

    return <></>
}

export default DFPAdManager
